import '../App.css';
import DescriptionTT from './AccueilSections/DescriptionTT';
import Avis from './AccueilSections/Avis';
import Services from './Services.js'
import { useState } from 'react';
import { useEffect } from 'react';
import axios from 'axios';

export default function Description() {
  return (
    <div id='accueilContainer'>
      <DescriptionTT></DescriptionTT>
      <Services></Services> 
      <Avis></Avis>
    </div>
  );
}